var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2943 16.8556H5.26075C1.3117 16.8556 0.111115 15.655 0.111115 11.706V5.41526C0.111115 1.46621 1.3117 0.265625 5.26075 0.265625H16.2843C20.2334 0.265625 21.434 1.46621 21.434 5.41526V11.696C21.4439 15.655 20.2433 16.8556 16.2943 16.8556ZM5.26075 1.75396C2.14517 1.75396 1.59945 2.29968 1.59945 5.41526V11.696C1.59945 14.8116 2.14517 15.3573 5.26075 15.3573H16.2843C19.3999 15.3573 19.9456 14.8116 19.9456 11.696V5.41526C19.9456 2.29968 19.3999 1.75396 16.2843 1.75396H5.26075Z",
    fill: "url(#paint0_linear_976_151271)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7775 21.5983C10.5805 21.597 10.392 21.5182 10.2527 21.3789C10.1134 21.2397 10.0346 21.0511 10.0333 20.8542V16.1114C10.0346 15.9144 10.1134 15.7259 10.2527 15.5866C10.392 15.4473 10.5805 15.3685 10.7775 15.3672C10.9745 15.3685 11.163 15.4473 11.3023 15.5866C11.4415 15.7259 11.5204 15.9144 11.5217 16.1114V20.8542C11.5204 21.0511 11.4415 21.2397 11.3023 21.3789C11.163 21.5182 10.9745 21.597 10.7775 21.5983Z",
    fill: "url(#paint1_linear_976_151271)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6997 12.67H0.855282C0.658318 12.6687 0.46979 12.5899 0.330513 12.4506C0.191235 12.3113 0.112415 12.1228 0.111115 11.9258C0.112415 11.7288 0.191235 11.5403 0.330513 11.401C0.46979 11.2618 0.658318 11.1829 0.855282 11.1816H20.6997C20.8967 11.1829 21.0852 11.2618 21.2245 11.401C21.3638 11.5403 21.4426 11.7288 21.4439 11.9258C21.4426 12.1228 21.3638 12.3113 21.2245 12.4506C21.0852 12.5899 20.8967 12.6687 20.6997 12.67Z",
    fill: "url(#paint2_linear_976_151271)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2425 21.5977H6.3125C6.11553 21.5964 5.927 21.5176 5.78773 21.3783C5.64845 21.239 5.56963 21.0505 5.56833 20.8535C5.56963 20.6566 5.64845 20.4681 5.78773 20.3288C5.927 20.1895 6.11553 20.1107 6.3125 20.1094H15.2425C15.4395 20.1107 15.628 20.1895 15.7673 20.3288C15.9065 20.4681 15.9854 20.6566 15.9867 20.8535C15.9854 21.0505 15.9065 21.239 15.7673 21.3783C15.628 21.5176 15.4395 21.5964 15.2425 21.5977Z",
    fill: "url(#paint3_linear_976_151271)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43399 9.39574C8.34173 9.39601 8.25035 9.3779 8.16517 9.34247C8.07999 9.30703 8.00272 9.25498 7.93788 9.18936L6.05861 7.31207C5.92844 7.17975 5.8555 7.00157 5.8555 6.81596C5.8555 6.63035 5.92844 6.45217 6.05861 6.31985L7.93788 4.44058C8.07236 4.32445 8.2458 4.26351 8.42337 4.27C8.60093 4.27649 8.76946 4.34994 8.8951 4.47558C9.02074 4.60122 9.09418 4.76975 9.10068 4.94731C9.10717 5.12488 9.04623 5.29832 8.9301 5.4328L7.54992 6.81596L8.9301 8.19316C9.06026 8.32549 9.13321 8.50366 9.13321 8.68928C9.13321 8.87489 9.06026 9.05306 8.9301 9.18539C8.86559 9.25173 8.78847 9.30451 8.70328 9.34064C8.61808 9.37676 8.52653 9.39549 8.43399 9.39574Z",
    fill: "url(#paint4_linear_976_151271)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.123 9.39766C13.0308 9.39793 12.9394 9.37982 12.8542 9.34439C12.769 9.30895 12.6918 9.2569 12.6269 9.19128C12.4968 9.05896 12.4238 8.88078 12.4238 8.69517C12.4238 8.50956 12.4968 8.33138 12.6269 8.19906L14.0091 6.81788L12.6259 5.43671C12.5098 5.30223 12.4489 5.12878 12.4554 4.95122C12.4619 4.77365 12.5353 4.60512 12.6609 4.47948C12.7866 4.35384 12.9551 4.2804 13.1327 4.27391C13.3102 4.26742 13.4837 4.32835 13.6182 4.44448L15.4974 6.32177C15.6276 6.45409 15.7005 6.63227 15.7005 6.81788C15.7005 7.00349 15.6276 7.18167 15.4974 7.31399L13.6202 9.18929C13.5554 9.2554 13.478 9.30788 13.3926 9.34366C13.3073 9.37945 13.2156 9.39781 13.123 9.39766Z",
    fill: "url(#paint5_linear_976_151271)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_976_151271",
    x1: 16.8727,
    y1: 2.95936,
    x2: 3.22813,
    y2: 15.8392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_976_151271",
    x1: 11.2033,
    y1: 16.3789,
    x2: 9.45604,
    y2: 16.6854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_976_151271",
    x1: 16.8804,
    y1: 11.4233,
    x2: 16.6496,
    y2: 13.8536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_976_151271",
    x1: 13.758,
    y1: 20.351,
    x2: 13.2984,
    y2: 22.7139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_976_151271",
    x1: 8.43205,
    y1: 5.10188,
    x2: 5.18237,
    y2: 6.62791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_976_151271",
    x1: 14.9996,
    y1: 5.10546,
    x2: 11.751,
    y2: 6.63111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2275A1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.5de8b8a27252daf688c14ab7b6a8ca50.svg";
export { ForwardRef as ReactComponent };